<!-- 折线图 -->
<style lang="stylus" scoped>
.bar-wrap {
  height: 80vh;
  width: 60vw;
  margin-left: 1vh;
  background: url('../../../../../assets/img/industryInformation/map-bg.png');
  background-size: 100% 100%;
  padding: 50px 30px;
  box-sizing: border-box;
  position: relative;

  .map {
    width: 60vw;
    height: 80vh;
    background-color: transparent !important;
  }

  .modal {
    position: absolute;
    width: 230px;
    height: 80px;
    background: rgba(7, 49, 81, 0.8);
    top: 30vh;
    left: 30vh;
    z-index: 1000;
    color: #fff;
    font-size: 20px;
    padding: 20px;
    box-sizing: border-box;
  }
}
</style>

<style>
.amap-logo,
.amap-copyright {
  display: none !important;
}
</style>


<template>
  <div class="bar-wrap"><v-map></v-map></div>
</template>
<script>

import map from '../center/index'

export default {
  data() {
    return {
      areaName: '田阳县'
    }
  },
  components: {
    'v-map': map
  },
  mounted() {
  },
  created() {
  }
}

</script>
 


// WEBPACK FOOTER //
// index.vue?29aaf984